import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import PageItem from 'global/page/PageItem'
import _ from 'lodash'
import { useContext, useEffect, useMemo, useState } from 'react'
import { PageAreaContext } from '../PageAreaContext'
import { SwiperContext } from '../SwiperContext'


export const useSwiperContent = ({
  activeIndex,
  swipeContentType,
  preloadDistance = 0
}) => {

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown } = pageArea_state ?? {}

  const [pageItemsLoaded, setPageItemsLoaded] = useState(_.mapValues(pageItemsShown, (pis) => pis.position === 0 ? true : false))

  const swiperContext = useContext(SwiperContext)
  const { swiper_state, swiper_handlers, swiper_fns } = swiperContext ?? {}
  const { swiperContent, currentSwipeIndex, uiElems } = swiper_state ?? {}

  const uiElemz = useMemo(() => {
    if (!uiElems) return;
    const _content = []
    _.forEach(uiElems, (uiElem, idx) => {
      const { key, content } = uiElem
      _content.push(content)
    })
    return { content: _content }
  }, [])

  const contents = useMemo(() => {
    if (!pageItemsShown || swipeContentType !== gEnums.swipeContentTypes.pageAreaContent) { return [] }
    let tabIndex = 0
    const _pacs = _.map(pageItemsShown, (csi, csiKey) => {
      const isMounted = pageItemsLoaded?.[csiKey]
      return <PageItem
        key={uniqueKey('sipi', csiKey)}
        uivi={csiKey}
        tabIndex={tabIndex}
        returnCount={true}
        from={'aaa'}
        inSwiper={true}
        isMounted={isMounted}
      />
    })
    console.log('_pacs', _pacs)
    return _pacs
  }, [pageItemsShown])

  useEffect(() => {
    if (_.isEmpty(contents)) { return; }
    const nextPageItemsLoaded = _.cloneDeep(contents)
    const pi = _.get(_.values(pageItemsShown), activeIndex)
    nextPageItemsLoaded[pi?.key] = true
    setPageItemsLoaded(nextPageItemsLoaded)
  }, [activeIndex, preloadDistance, _.size(contents)])

  switch (swipeContentType) {
    case gEnums.swipeContentTypes.groupedItems:
      return { swiperMenu: uiElemz?.tabs, swiperContent: uiElemz?.content }
    default:
      return { swiperContent: contents }
  }
}